import _ from 'lodash';
import { getField, updateField } from 'vuex-map-fields';
const state = {
    asistente_step: '',
    id_consignacion: '',
    vehiculoData: {
        vehiculo: {},
        inspeccion: {
            proceso: {
                fotos: {}
            }
        }
    },
    credito: {
        v_vehiculo: 0,
        v_inicial: 0,
        vr_financiar: 0,
        plazo: 0,
        v_cuota: 0
    },
    cliente: {
        nombre: '',
        apellido: '',
        email: '',
        celular: '',
        actividad: '',
        ingresos: '',
        mensaje: '',
    }
};
/**Esto son funciones que modifican el estado original */
const mutations = {
    updateField
};
/**Esta funcion trae valores de los estados */
const getters = {
    getField
};
export default {
    namespaced: true,
    state,
    mutations,
    getters
}
